var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndowhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81336 10.7149H1.3391C0.597014 10.7149 0 10.1179 0 9.37582V2.23397C0 1.69275 0.323615 1.20175 0.825776 0.995306C1.32794 0.788862 1.90263 0.900454 2.28762 1.28544L4.60872 3.60654C9.49642 -1.21978 17.3692 -1.20304 22.229 3.66234C27.1111 8.54446 27.1111 16.4563 22.229 21.3384C17.3469 26.2205 9.43505 26.2205 4.55293 21.3384C3.85548 20.641 3.85548 19.5083 4.55293 18.8109C5.25037 18.1134 6.38302 18.1134 7.08047 18.8109C10.5677 22.2981 16.2198 22.2981 19.707 18.8109C23.1943 15.3236 23.1943 9.67153 19.707 6.1843C16.2365 2.71381 10.6291 2.69707 7.13627 6.12851L9.42947 8.42729C9.81446 8.81228 9.92605 9.38697 9.71961 9.88914C9.51316 10.3913 9.02216 10.7149 8.48094 10.7149H1.81336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndowhite);
export default __webpack_public_path__ + "static/media/undo white.e87f5703ef19b03afdda2c62a106df09.svg";
export { ForwardRef as ReactComponent };